import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../../../Config'
import Select from 'react-select'
import * as Utils from "../../../../inc/Utils";
import moment from "moment-timezone";

export default function MasterProjectItemCreate(props) {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [buttonText, setButtonText] = React.useState(btnTextDefault);
    let [campaignDetail, setCampaignDetail] = React.useState(null);

    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {

            const resCampaignDetail = await Utils.getGenerateCampaignView(props.generateGroupCampaignId);
            setCampaignDetail(resCampaignDetail);

            const resSetNameType = await Utils.getAdsNamingSetNameType();
            setAdsNamingSetNameType(resSetNameType);

            let resView = null;
            let adsNamingSetNameTypeId = null;
            if(props.itemId) {
                resView = await getView(props.itemId);
                refName.current.value = resView.name;
                adsNamingSetNameTypeId = resSetNameType.filter(e => e.id === resView.adsNamingSetNameTypeId)[0];
                setAdsNamingSetNameTypeId(adsNamingSetNameTypeId);
            }

            //-- AdsSet
            await adssetDetail(resView);

            //-- UTM
            await utmDetail(resCampaignDetail, adsNamingSetNameTypeId, resView);

            try {
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/generateGroupCampaignMaster/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = async () => {

        //Check select UTM item
        let selectSourceTypeIds = document.getElementsByName('utmSourceTypeIds[]');
        let sourceTypeIds = [];
        if(selectSourceTypeIds) {
            setLoading(true);
            setButtonText('กำลังตรวจสอบ UTM...');

            for(let st of selectSourceTypeIds) {
                if(st.value) {
                    let utmSourceTypeId = st.value;
                    let utmSourceId = 0;
                    let utmSourceTypeText = null;
                    let inputType = null;

                    let sourceTypeRow = await Utils.getUtmSourceTypeById(utmSourceTypeId);
                    utmSourceId = sourceTypeRow.utmSourceId;
                    utmSourceTypeText = sourceTypeRow.name;

                    sourceTypeIds.push({
                        utmSourceId: utmSourceId,
                        utmSourceTypeId: utmSourceTypeId,
                        utmSourceTypeText: utmSourceTypeText,
                        inputType: inputType
                    });
                }
            }
            setLoading(false);
            setButtonText(btnTextDefault);
        }

        let adssetParam = await getAdsSetParams();

        let name = refName.current.value;

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Ads Set & UTM");
            refName.current.focus();
        }
        else if(!adssetParam.success) {
            toast.error("กรุณาเลือก Ads Set Parameters ให้ครบถ้วน");
        }
        else if(!adsNamingSetNameTypeId) {
            toast.error("กรุณาระบุ Ads Set Type");
        }
        else if(!utmTemplateId) {
            toast.error("กรุณาเลือก UTM Template");
        }
        else if(sourceTypeIds.length !== selectSourceTypeIds.length) {
            toast.error("กรุณาเลือก UTM ให้ครบถ้วน");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);
                            setButtonText(btnTextLoading);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                name: name,
                                generateGroupId: props.generateGroupId,
                                generateGroupCampaignId: props.generateGroupCampaignId,
                                utmTemplateId: utmTemplateId != null ? utmTemplateId.id : null,
                                adsPlatformId: platformId ? platformId.id : null,
                                hashtag: hashtag ? hashtag.id : null,
                                adsNamingSetNameTypeId: adsNamingSetNameTypeId ? adsNamingSetNameTypeId.id : null,
                                status: statusChecked[0].checked ? 1:0,
                                adssetSourceTypeIds: adssetParam.data,
                                utmSourceTypeIds: sourceTypeIds,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };

                            let url = Config.url.API_URL +'/api/generateGroupCampaignMaster/create';
                            if(props.itemId) {
                                url = Config.url.API_URL +'/api/generateGroupCampaignMaster/update';
                                body.id = props.itemId;
                            }

                            fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate(props.backPath, {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    //region -- Ads Set
    let [adsNaming, setAdsNaming] = React.useState('');
    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState('');
    let [adsNamingSetNameTypeId, setAdsNamingSetNameTypeId] = React.useState(null);
    let [platform, setPlatform] = React.useState(null);
    let [platformId, setPlatformId] = React.useState(null);
    let [adssetItemSelected, setAdssetItemSelected] = React.useState(null);
    let [adssetItemFreeForm, setAdssetItemFreeForm] = React.useState('');
    let [adssetExample, setAdssetExample] = React.useState('');

    const adssetDetail = async (resView) => {
        const resPlatform = await Utils.getPlatformAll();
        setPlatform(resPlatform);

        const resAdssetName = await Utils.getAdsNamingSetName();
        if(resAdssetName.length > 0) {
            let ex = [];
            let ex2 = [];
            let newAdssetName = [];
            if(resAdssetName) {
                newAdssetName = resAdssetName.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
                let xLen = newAdssetName.length;
                if(xLen > 1) {
                    for(let i=0;i<2;i++) {
                        ex.push('{' + newAdssetName[i].name + '}');
                    }
                }
                if(xLen > 2) {
                    for(let j=2;j<xLen;j++) {
                        ex2.push('{' + newAdssetName[j].name + '}');
                    }
                }
            }
            setAdssetExample(ex.join('_') + '|' + ex2.join('_') + '_{Platform}|{Type}_[ST]');
            setAdsNaming(newAdssetName);
        }

        if(resView) {
            if(resPlatform && resView.adsPlatformId) {
                setPlatformId(resPlatform.filter(e => e.id === resView.adsPlatformId)[0]);
            }
            let items = resView.adssetItems;
            let sourceTypeSelectedIds = [];
            if (items) {
                for (let rs of items) {
                    let adsNamingSourceId = rs.adsNamingSourceId;
                    if (adsNamingSourceId) {
                        sourceTypeSelectedIds.push(adsNamingSourceId);
                    }

                    if(rs.inputType === Utils.ADSNAMING_TYPE_FREEFORM && items && items.length > 0) {
                        setAdssetItemFreeForm(items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0].text);
                    }
                }
            }
            setAdssetItemSelected(sourceTypeSelectedIds);
        }
    };
    const onChangeAdsNamingSetNameTypeId = async (obj) => {
        setAdsNamingSetNameTypeId(obj);
        setUtmTemplateId(null);
    };
    async function getAdsSetParams() {
        let textParams = [];
        let sourceIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('adssetSourceTypeIds[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    sourceTypeIds.push(sourceTypeId);
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adsNaming.length > 0) {
            adsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "adssetSourceTypeText[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);
                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    if(value.length > 0 || row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: value,
                            inputType: row.inputType
                        });
                    }
                }
                else {
                    let find = sourceIds.find(rs => {
                        if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                            return rs;
                        }
                    });
                    if(find && find.name) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.name,
                            inputType: null
                        });
                    }
                }
            });
        }

        return {params: null, data: textParams, success: sourceTypeAllIds.length === selectSourceTypeIds.length};
    }
    const onChangePlatformId = async (platformRow) => {
        setPlatformId(platformRow);
    };
    //endregion

    //region -- UTM
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [utmTemplateId, setUtmTemplateId] = React.useState(null);
    let [hashtagList, setHashtagList] = React.useState(null);
    let [hashtag, setHashtag] = React.useState(null);
    let [utm, setUtm] = React.useState('');
    let [showUTMListing, setShowUtmListing] = React.useState(false);
    let [templateSource, setTemplateSource] = React.useState('');
    let [itemSelected, setItemSelected] = React.useState('');
    let [contentId, setContentId] = React.useState(null);
    let [ownerId, setOwnerId] = React.useState(null);

    const utmDetail = async (campaignDetail, adsNamingSetNameTypeId, resView) => {
        const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
        setUtmTemplate(resTemplate);
        const resHashtag = await Utils.getHashtag();
        setHashtagList(resHashtag);

        if(resView) {
            if(resTemplate && resView.utmTemplateId) {
                let selectedTemplate = resTemplate.filter(e => e.id === resView.utmTemplateId)[0];
                setUtmTemplateId(selectedTemplate);
                await onChangeTemplateId(selectedTemplate, campaignDetail, adsNamingSetNameTypeId);
            }
            if(resHashtag && resView.hashtag) {
                setHashtag(resHashtag.filter(e => e.id === resView.hashtag)[0]);
            }

            let sourceTypeSelectedIds = [];
            if(resView.utmItems) {
                let itemSource = resView.utmItems;
                for(let rs of itemSource) {
                    let utmSourceTypeId = rs.utmSourceTypeId;
                    if(utmSourceTypeId) {
                        sourceTypeSelectedIds.push(parseInt(utmSourceTypeId));
                    }
                }
                setItemSelected(sourceTypeSelectedIds);
            }
        }
    };
    const onChangeTemplateId = async (obj, campaignDetail, adsNamingSetNameTypeIdTmp) => {
        setShowUtmListing(false);
        setUtmTemplateId(obj);

        if(adsNamingSetNameTypeIdTmp) {
            adsNamingSetNameTypeId = adsNamingSetNameTypeIdTmp;
        }

        if(obj && obj.id) {
            const resSource = await Utils.getTemplateSourceById(obj.id);
            setTemplateSource(resSource);
            const resUtm = await Utils.getUtmByIds(resSource);
            setShowUtmListing(true);

            if(resSource.length > 0) {
                for(let utm of resUtm) {
                    if(resSource) {
                        let ex = [];
                        for(let rs of resSource) {
                            if(utm.id === rs.utmId) {
                                ex.push('{' + rs.source.name + '}');

                                if(rs.source.name === 'Target' && adsNamingSetNameTypeId) {
                                    rs.source.sourceType = rs.source.sourceType.filter(r => r.name === adsNamingSetNameTypeId.name);
                                }
                                else if(rs.source.name === 'Objective' && campaignDetail) {
                                    let namingObj = campaignDetail.items.filter(e => e.naming.name === 'Objective')[0];
                                    rs.source.sourceType = rs.source.sourceType.filter(r => r.name === namingObj.source.name);
                                }
                            }
                        }
                        utm.example = ex.join('_');
                    }
                }
            }
            setUtm(resUtm);
        }
    };
    const onChangeHashtag = (obj) => {
        setHashtag(obj);
    };
    //endregion

    return (
        <>
            <div className="col-12">
                <div className="col-12 mt-1">
                    <label htmlFor="name" className="form-label">ชื่อ Ads Set & UTM <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                </div>
            </div>

            <div className="col-12">
                <div className="row">
                    <div className="col-6">
                        <ul className="nav nav-tabs mt-3" id="myTab" role="tablist">
                            <li className="nav-item ms-1" role="presentation">
                                <button className="nav-link adsset-color active" id="tabAdsSet-tab" data-bs-toggle="tab"
                                        data-bs-target="#tabAdsSet" type="button" role="tab" aria-controls="profile"
                                        aria-selected="false">Ads Set
                                </button>
                            </li>
                        </ul>

                        <div className="tab-content" id="myTabContent1">
                            <div className="tab-pane p-2 adsset-bg fade show active" id="tabAdsSet" role="tabpanel"
                                 aria-labelledby="tabAdsSet-tab">
                                <div className="row g-3 p-2">
                                    <div className="col-12">
                                        <div className="d-block mb-1 small">{adssetExample}</div>
                                    </div>

                                    <div className="col-12">
                                        <label htmlFor="platformId" className="form-label">Platform</label>
                                        <Select
                                            classNamePrefix="form-select-search"
                                            options={platform}
                                            onChange={(event) => onChangePlatformId(event)}
                                            value={platformId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    {
                                        adsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                            adsNaming.map((row, index) => {
                                                let disabled = false;
                                                let inputText = "adssetSourceTypeText["+row.id+"]";
                                                let formId = '';
                                                let source = row.source;
                                                let inputType = row.inputType;

                                                let selected = null;

                                                if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                    formId = 'slug-project';
                                                    return (
                                                        <div key={index} className="col-12">
                                                            <div className="d-block fw-bold">{row.name}
                                                                <span className="text-muted small d-block fw-light">{'{lang}-{project-type-slug}-{project-slug}'}</span>
                                                            </div>
                                                            <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} disabled={true} /></div>
                                                        </div>
                                                    );
                                                }
                                                else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                    //--
                                                }
                                                else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                    //--
                                                }
                                                else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                    formId = 'freeform';
                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name}</div>
                                                            <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} defaultValue={adssetItemFreeForm} onKeyUp={e => {
                                                                if(e && e.target.value) {
                                                                    e.target.value = Utils.utmSlug(e.target.value);
                                                                }
                                                            }} /></div>
                                                        </div>
                                                    );
                                                }
                                                else {

                                                    if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                        source = platformId ? source.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id)) : source;
                                                    }

                                                    if(adssetItemSelected) {
                                                        for(let cs of source) {
                                                            let id = cs.id;
                                                            if(adssetItemSelected.includes(id)) {
                                                                selected = {id: id, name: cs.name};
                                                                break;
                                                            }
                                                        }
                                                    }

                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                            <Select
                                                                isClearable={false}
                                                                isDisabled={disabled}
                                                                name="adssetSourceTypeIds[]"
                                                                classNamePrefix="form-select-search"
                                                                options={source}
                                                                defaultValue={selected}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            })
                                    }
                                </div>

                                <div className="row g-3 p-2">
                                    <div className="col-12">
                                        <label htmlFor="adsNamingSetNameType" className="form-label">Type <span className="text-danger">*</span></label>
                                        <Select
                                            classNamePrefix="form-select-search"
                                            options={adsNamingSetNameType}
                                            onChange={(event) => onChangeAdsNamingSetNameTypeId(event)}
                                            value={adsNamingSetNameTypeId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <ul className="nav nav-tabs mt-3" id="myTab" role="tablist">
                            <li className="nav-item ms-1" role="presentation">
                                <button className="nav-link utm-color active" id="tabUTM-tab" data-bs-toggle="tab"
                                        data-bs-target="#tabUTM" type="button" role="tab" aria-controls="tabUTM"
                                        aria-selected="false">UTM
                                </button>
                            </li>
                        </ul>

                        <div className="tab-content" id="myTabContent2">
                            <div className="tab-pane p-2 utm-bg fade show active" id="tabUTM" role="tabpanel"
                                 aria-labelledby="tabUTM-tab">
                                <div className="row g-3 p-2">
                                    <div className="col-12">
                                        <label htmlFor="template" className="form-label">Template <span className="text-danger">*</span></label>
                                        <Select
                                            classNamePrefix="form-select-search"
                                            options={utmTemplate}
                                            onChange={(event) => onChangeTemplateId(event, campaignDetail)}
                                            value={utmTemplateId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>

                                    <div className={"col-12 " + (utmTemplateId === null ? 'd-none' : '')}>
                                        {
                                            utm.length <= 0 ? '' :
                                                utm.map((row, index) => {
                                                    return (
                                                        showUTMListing ? <div key={index} className={"border rounded bg-yellow-light p-2" + (index+1 !== utm.length ? ' mb-3' : '')}>
                                                            <div className="d-block fw-bold">{(row.utmPrefix === 1 ? 'utm_':'') + row.name.toLowerCase()} <span className="text-danger">*</span></div>
                                                            <div className="d-block mb-1 small">{row.example}</div>
                                                            {
                                                                templateSource.length <= 0 ? (<p>ไม่พบข้อมูล source</p>) :
                                                                    templateSource.map((rs, index2) => {
                                                                        if(rs.source && rs.utmId === row.id) {
                                                                            let disabled = false;
                                                                            let rsSource = rs.source.sourceType;
                                                                            let inputType = rs.source.inputType;
                                                                            let selected = null;


                                                                            if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                                                                disabled = true;
                                                                                rsSource = [];
                                                                            }
                                                                            else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                                                                disabled = true;
                                                                                rsSource = [];
                                                                            }
                                                                            else if(inputType === Utils.API_TYPE_CAMPAIGN_ID
                                                                                || inputType === Utils.API_TYPE_CAMPAIGN_NAME
                                                                                || inputType === Utils.API_TYPE_PROJECT_ID
                                                                                || inputType === Utils.API_TYPE_PROJECT_NAME
                                                                                || inputType === Utils.API_TYPE_PROJECT_SLUG
                                                                                || inputType === Utils.API_TYPE_PROMOTION_SLUG
                                                                                || inputType === Utils.API_TYPE_LINE_OAID
                                                                            ) {
                                                                                disabled = true;
                                                                                rsSource = [];
                                                                            }
                                                                            else {
                                                                                if(rsSource) {
                                                                                    for(let s of rsSource) {
                                                                                        if(itemSelected.length && itemSelected.includes(s.id)) {
                                                                                            selected = {id: s.id, name: s.name};
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }

                                                                            if(rs.source.name === 'Target') {
                                                                                selected = rsSource;
                                                                            }
                                                                            else if(rs.source.name === 'Objective') {
                                                                                selected = rsSource;
                                                                            }

                                                                            return (
                                                                                <div key={index2} className="ms-2 mt-3">
                                                                                    <div className="row mt-2">
                                                                                        <div className="col-12 col-sm-4 text-end small">
                                                                                            {rs.source.name} :
                                                                                        </div>
                                                                                        <div className="col-12 col-sm-8">
                                                                                            <span className="text-muted small fw-light">{
                                                                                                inputType === Utils.API_TYPE_PROJECT_NAME ?
                                                                                                    '{lang}-{project_type_slug}-{project_slug}' : ''
                                                                                            }</span>
                                                                                            <Select
                                                                                                isClearable={false}
                                                                                                isDisabled={disabled}
                                                                                                name="utmSourceTypeIds[]"
                                                                                                classNamePrefix="form-select-search"
                                                                                                placeholder={rsSource.length ? 'Select...':'...'}
                                                                                                options={rsSource}
                                                                                                defaultValue={selected}
                                                                                                getOptionValue={(option) => `${option.id}`}
                                                                                                getOptionLabel={(option) => `${option.name}`}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    })
                                                            }
                                                        </div> : ''
                                                    );
                                                })
                                        }
                                    </div>

                                    <div className="col-12">
                                        <label htmlFor="typeIed" className="form-label">Hashtag (#)</label>
                                        <Select
                                            classNamePrefix="form-select-search"
                                            options={hashtagList}
                                            onChange={(event) => onChangeHashtag(event)}
                                            value={hashtag}
                                            getOptionValue={(option) => `${option.name}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <label htmlFor="statusx" className="form-label">สถานะ</label>
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                    <label className="form-check-label" htmlFor="status"></label>
                </div>
            </div>

            <div className="col-12">
                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading}><span
                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {buttonText}</button>
                <NavLink className="btn btn-sm btn-light ms-2" to={props.backPath}><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                <Toaster position="bottom-right" />
            </div>
        </>
    );
} 